// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Ob9k","footer":"ModalError_footer__3-wRe"};